import React from 'react';
import PropTypes from 'prop-types';
import { Carousel } from '@vds/carousels';

import { isDesktopResolution } from '../../../../../common/Helpers';
import '../../addons.css';

const AddonCarousel = (props) => (
  <Carousel
    peek="minimum"
    layout={isDesktopResolution() ? '2UP' : '1UP'}
    gutter="24px"
    surface="light"
    pagination={{
      kind: 'highContrast',
      hideBorder: true,
      floating: true,
    }}
    paginationInset="12px"
    paginationDisplay="persistent"
    aspectRatio="none"
    data={props.data}
    renderItem={props.renderItem}
  />
);

AddonCarousel.propTypes = {
  data: PropTypes.array,
  renderItem: PropTypes.func,
};

export default AddonCarousel;
